import BaseRouter from 'nast-router'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import { sync, } from 'vuex-router-sync'
import { homeRouteName, rolesFromToken } from '@/helpers/roles'
/**
 *
 */
export default class NastRouter extends BaseRouter {

  // eslint-disable-next-line require-jsdoc
  router() {
    if (!this._router) {
      this._vue.use(Meta, {
        keyName: 'html',
        attribute: 'dv-meta',
        ssrAttribute: 'dv-meta-server-rendered',
        tagIDKeyName: 'mid',
      })

      this._vue.use(VueRouter)

      this._router = new VueRouter({
        ...this._config('config'),
        fallback: false,
        routes: this._routes,
      })

      this._router.beforeEach((to, from, next) => {
        if ('login' === to.name) {
          try {
            if ($app?.auth?.logout) {
              $app.auth.logout(false);
            } else if (this._store) {
              this._store.commit('auth/logout');
            }
          } catch (e) {
            console.error('[Router] Ошибка при очистке авторизации', e);
          }
          return next();
        }

        if (this._checkAccess(to)) {
          next();
        } else if (this._homeRoute() && this._homeRoute() !== to.name) {
          // Авторизован, но раздел не для его роли (например, ФД открыл «Компании») — ведём на свою стартовую.
          next({ name: this._homeRoute() });
        } else {
          if ($app?.auth?.logout) {
            $app.auth.logout(false);
          } else {
            this._store.commit('auth/logout');
          }
          next({ name: 'login' });
        }
      });
      sync(this._store, this._router)
    }

    return this._router
  }

  /**
     * Стартовая страница текущего пользователя по ролям из токена.
     * @return {String|null} - Имя маршрута.
     */
  _homeRoute() {
    const auth = JSON.parse(localStorage.getItem('auth'));
    return homeRouteName(rolesFromToken(auth?.token));
  }

  /**
     * Проверяет, есть ли у пользователя доступ к маршруту.
     * @param {Object} route - Объект маршрута.
     * @return {Boolean} - Доступ разрешен или нет.
     */
  _checkAccess(route) {
    const auth = JSON.parse(localStorage.getItem('auth'));
    const token = auth?.token;

    if (token) {
      try {
        const decodedToken = atob(token.split('.')[1])
        const tokenData = JSON.parse(decodedToken)
        const userRoles = tokenData.authorities || [];
        if (route.meta?.roles && route.meta.roles.length > 0) {
          return route.meta.roles.some((role) => userRoles.includes(role));
        }

        return true;
      } catch (error) {
        return false;
      }
    }
    return false;
  }
}
